import type { GameState, Obstacle } from './types'
import { CAR_CONFIG, PHYSICS_CONFIG, SPAWN_CONFIG } from './config'

const createInitialState = (): GameState => ({
  tPrev: 0,
  elapsed: 0,
  groundY: 0,
  car: {
    x: CAR_CONFIG.startX,
    y: 0,
    w: CAR_CONFIG.width,
    h: CAR_CONFIG.height,
    vy: 0,
    onGround: true,
  },
  gravity: PHYSICS_CONFIG.gravity,
  jumpVelocity: PHYSICS_CONFIG.jumpVelocity,
  speed: PHYSICS_CONFIG.initialSpeed,
  speedInc: PHYSICS_CONFIG.speedIncrement,
  obstacles: [] as Obstacle[],
  spawnCooldown: SPAWN_CONFIG.initialCooldown,
  nextSpawnIn: SPAWN_CONFIG.initialNextSpawn,
  seed: 123456,
  score: 0,
  best: 0,
  lastScoreAtCrash: 0,
  safeAfterLastObstaclePx: PHYSICS_CONFIG.minSafeDistancePx,
  minGapPx: PHYSICS_CONFIG.minGapPx,
  scenery: null,
})

export { createInitialState }
